"use strict";
define(
    'stores/clips',[
        "jquery",
        "stores/store",
        "actions/clips",
        "constants/actiontypes"
    ],
    function ($, StoreBase, Action, Constants)
    {
        Store.prototype = new StoreBase();
        Store.constructor = Store;

        function Store (params)
        {
            // Call parent constructor
            StoreBase.call(this, params);

            // Setup the instance
            this.items = {};

            this.registerDispatchListener(function (action) {
                var self = this;
                switch(action.actionType) {
                    case Constants.CREATED_CLIP:
                        if (Array.isArray(action.data)) {
                            _.each(action.data, function (data, index, list) {
                                this.addItem(data);
                            }, this);
                        } else {
                            this.addItem(action.data);
                        }
                        this.event.emit("change");
                        break;
                    case Constants.UPDATED_CLIP:
                        if(this.items[action.guid]) {
                            _.each(action.data, function(value, key) {
                                self.items[action.guid][key] = value;
                            });
                        }
                        this.event.emit("change");
                        break;
                    case Constants.DELETED_CLIP:
                        if(this.items[action.guid]) {
                            delete this.items[action.guid];
                        }
                        this.event.emit("change");
                        break;
                }
            }.bind(this));

            this.action = new Action();
            // this.action.pull();
        }

        Store.prototype.addItem = function(data)
        {
            if(this.items[data.guid.toLowerCase()]) {
                delete this.items[data.guid.toLowerCase()];
            }
            this.items[data.guid.toLowerCase()] = data;
        };

        Store.prototype.getAll = function(filterOptions)
        {
            var clips;

            if(filterOptions) {
                var keywordRegExp = null;
                if(filterOptions.keyword && filterOptions.keyword.trim().length >= 3)
                    keywordRegExp = new RegExp(filterOptions.keyword.trim().replace(/ /g, "|"), "i");

                clips = _.filter(this.items, function(clip) {
                    if(keywordRegExp && !keywordRegExp.test(clip.title))
                        return;

                    return clip;
                });
            }
            else {
                clips = _.map(this.items, function(clip) {
                    return clip;
                });
            }

            return clips;
        };

        Store.prototype.hasItem = function(id)
        {
            return (id.toLowerCase() in this.items);
        };

        Store.prototype.getItem = function(id)
        {
            return this.items[id.toLowerCase()];
        };

        Store.prototype.clearSectionCache = function(sectionId){
            delete this.sectionCache[sectionId];
        };

        return Store;
    });

